module.exports = __webpack_public_path__ + "img/icon--schedule--white.57592b75.svg";